<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AuthShell from '@/components/AuthShell.vue'
import { novaApi } from '@/services/api'
import { authSession, formatAuthError } from '@/services/auth'
import { buildNovaAiLaunchUrl } from '@/services/nova-ai-sso'

const route = useRoute()
const errorMessage = ref('')
const loading = ref(true)

const enterNovaAi = async () => {
  loading.value = true
  errorMessage.value = ''
  try {
    await authSession.initialize()
    const accessToken = await authSession.validAccessToken()
    const ticket = await novaApi.createNovaSsoTicket(accessToken)
    window.location.replace(buildNovaAiLaunchUrl(ticket, route.query.next))
  } catch (error) {
    loading.value = false
    errorMessage.value = formatAuthError(error, '暂时无法进入 AI 创作平台，请稍后重试。')
  }
}

onMounted(() => void enterNovaAi())
</script>

<template>
  <AuthShell>
    <div class="ai-login-view">
      <span v-if="loading" class="auth-spinner" aria-hidden="true"></span>
      <h1>{{ errorMessage ? '无法进入 AI 创作平台' : '正在进入 AI 创作平台' }}</h1>
      <p>{{ errorMessage || '正在创建安全登录凭证，请稍候。' }}</p>
      <button v-if="errorMessage" class="scan-load-action" type="button" @click="enterNovaAi">
        重新尝试
      </button>
    </div>
  </AuthShell>
</template>
